export default "__VITE_ASSET__66ac7f66__"